import { createAction, props } from '@ngrx/store';
import type { UserAccountProfileModel } from '@candyland/generic/shared/tt-com-anmeldung/models';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface ___oldBasicInformation {
  loginRadiusData: {
    Email: [{ Value: string }];
  };
  anmeldungData: {
    isCustomer: boolean;
  };
  permissions: {
    CanComment: boolean;
    PreviewArticle: boolean;
    PreviewAdvertorial: boolean;
    DebugApp: boolean;
    CanAccessPlusContent: boolean;
    CanAccessClub: boolean;
  };
}

export type UserAccountProfileModelBackwardsProjection = UserAccountProfileModel & ___oldBasicInformation;

export const appInitV2 = {
  startLoginCheck: createAction('[App Init] Start Login Check'),
};

export const initialLoginCheckV2 = {
  loggedIn: createAction('[Initial Login Check] OAuth2 logged in'),
  checkWithServer: createAction('[Initial Login Check] Check Login With Users API (LR Cookie Has Token)'),
  notLoggedIn: createAction('[Initial Login Check] Not Logged In (No Token Found In Query Or Param)'),
};

export const anmeldungTtLoginV2 = {
  loadUserData: createAction('[Anmeldung TT Login Success] Load User Data'),
  removeTokenQueryParam: createAction('[Anmeldung TT Login Success] Remove LR Token From Query'),
};

export const usersApiV2 = {
  loadUserDataSuccess: createAction(
    '[Users API] Load User Data Success',
    props<{ userData: UserAccountProfileModelBackwardsProjection }>()
  ),
  loadUserDataFailure: createAction('[Users API] Load User Data Failure', props<{ error: any }>()),
  loginCheckWasPositive: createAction(
    '[Users API] Login Check Was Positive',
    props<{ userData: UserAccountProfileModelBackwardsProjection }>()
  ),
  loginCheckWasNegative: createAction('[Users API] Login Check Was Negative'),
  loginCheckError: createAction('[Users API] Login Check Error', props<{ error: any }>()),
};

export const removeUserFromStoreV2 = createAction('[User Action] Remove User Data from Store');

export const checkInAppLoginV2 = createAction('[InApp Login] Check login with server');
